const TableControls = ({
  sortKey,
  sortDirection,
  onSortKeyChange,
  onSortDirectionChange,
  sortOptions = [],
  page,
  totalPages,
  totalItems,
  pageSize,
  onPageChange,
  onPageSizeChange,
  searchTerm,
  onSearchChange,
  searchPlaceholder = 'Search rows',
}) => {
  return (
    <div className="d-flex flex-column flex-lg-row gap-2 justify-content-between align-items-lg-center">
      <div className="d-flex flex-wrap align-items-center gap-2">
        <label className="form-label small mb-0" htmlFor="tableSortSelect">
          Sort by
        </label>
        <select
          id="tableSortSelect"
          className="form-select form-select-sm w-auto"
          value={sortKey}
          onChange={(event) => onSortKeyChange?.(event.target.value)}
        >
          {sortOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <button
          type="button"
          className="btn btn-outline-secondary btn-sm"
          onClick={() => onSortDirectionChange?.(sortDirection === 'asc' ? 'desc' : 'asc')}
        >
          {sortDirection === 'asc' ? 'Ascending' : 'Descending'}
        </button>
        {onSearchChange && (
          <div className="input-group input-group-sm ms-lg-2" style={{ minWidth: '260px' }}>
            <span className="input-group-text">Search</span>
            <input
              type="search"
              className="form-control"
              placeholder={searchPlaceholder}
              value={searchTerm || ''}
              onChange={(event) => onSearchChange(event.target.value)}
            />
            {searchTerm && (
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => onSearchChange('')}
              >
                Clear
              </button>
            )}
          </div>
        )}
      </div>

      <div className="d-flex flex-wrap align-items-center gap-2 justify-content-end">
        <label className="form-label small mb-0" htmlFor="tablePageSize">
          Rows per page
        </label>
        <select
          id="tablePageSize"
          className="form-select form-select-sm w-auto"
          value={pageSize}
          onChange={(event) => onPageSizeChange?.(Number(event.target.value))}
        >
          {[5, 10, 20, 50].map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>
        <div className="d-flex align-items-center gap-1 flex-wrap justify-content-end">
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            onClick={() => onPageChange?.(page - 1)}
            disabled={page <= 1}
          >
            Previous
          </button>
          {[...new Set([1, page - 1, page, page + 1, totalPages]
            .filter((value) => value >= 1 && value <= totalPages))]
            .sort((first, second) => first - second)
            .reduce((pages, current, index, array) => {
              if (index > 0 && current - array[index - 1] > 1) {
                pages.push('ellipsis-' + current);
              }
              pages.push(current);
              return pages;
            }, [])
            .map((value) =>
              typeof value === 'string' ? (
                <span key={value} className="text-muted small px-2">
                  ...
                </span>
              ) : (
                <button
                  key={value}
                  type="button"
                  className={`btn btn-sm ${value === page ? 'btn-primary' : 'btn-outline-secondary'}`}
                  onClick={() => onPageChange?.(value)}
                  aria-current={value === page}
                >
                  {value}
                </button>
              )
            )}
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            onClick={() => onPageChange?.(page + 1)}
            disabled={page >= totalPages}
          >
            Next
          </button>
          <span className="text-muted small ms-2">
            Page {page} of {totalPages} · {totalItems} row{totalItems === 1 ? '' : 's'}
          </span>
        </div>
      </div>
    </div>
  );
};

export default TableControls;
